import { OVERLAY_LAYERS } from '../config/overlayLayers';

export default function AdditionalGeographyPanel({ activeLayers, onToggle, onClose }) {
  return (
    <div className="gp-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="gp-panel" style={{ width: 360 }}>
        <div className="gp-header">
          <h2 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>Additional Geography</h2>
          <button
            className="gp-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="ag-panel-body">
          {OVERLAY_LAYERS.map(layer => (
            <label key={layer.id} className="ag-layer-row">
              <span
                className="ag-layer-swatch"
                style={{ background: layer.color }}
              />
              <span className="ag-layer-label">{layer.label}</span>
              <input
                type="checkbox"
                checked={activeLayers.has(layer.id)}
                onChange={() => onToggle(layer.id)}
              />
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
